import React from "react";
import { Box, Typography } from "@mui/material";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";
import { votePercents } from "../../utils/community";

const VoteBar = ({ matchup }) => {
  const { a, b, total } = votePercents(matchup);
  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          gap: 2,
          mb: 0.75,
        }}
      >
        <Typography variant="body2" fontWeight={700}>
          {matchup?.rosterA?.title || "Roster A"} · {a}%
        </Typography>
        <Typography variant="body2" fontWeight={700} textAlign="right">
          {b}% · {matchup?.rosterB?.title || "Roster B"}
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
          height: 10,
          borderRadius: 999,
          overflow: "hidden",
          bgcolor: "rgba(255,255,255,0.08)",
        }}
      >
        <Box
          sx={{
            width: `${total ? a : 50}%`,
            bgcolor: BRAND_COLORS.cyan,
          }}
        />
        <Box
          sx={{
            width: `${total ? b : 50}%`,
            bgcolor: brandRgba(BRAND_COLORS.cyan, 0.35),
          }}
        />
      </Box>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.75, display: "block" }}>
        {total.toLocaleString()} {total === 1 ? "vote" : "votes"}
      </Typography>
    </Box>
  );
};

export default VoteBar;
